import React from "react";
import "./WhyChooseUs.css";
import { useTranslation } from "./hooks/useTranslation";

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const reasons = [
    { text: t.whyChooseUsReason1 },
    { text: t.whyChooseUsReason2 },
    { text: t.whyChooseUsReason3 },
    { text: t.whyChooseUsReason4 },
    { text: t.whyChooseUsReason5 },
  ];

  return (
    <section className="why-choose-us">
      <div className="why-choose-us-container">
        <h2 className="animate-fadeIn">{t.whyChooseUsTitle}</h2>
        <p className="subtitle animate-fadeIn">
          {t.whyChooseUsSubtitle}
        </p>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-item animate-fadeIn">
              <p>{reason.text}</p>
            </div>
          ))}
        </div>

        <div className="read-more animate-fadeIn">
          <a href="/about">{t.readMore}</a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
